import React from 'react';
import AccountLayout from 'components/layouts/AccountLayout';
import SEOMeta from 'containers/SEOMeta';
import MetricsDownload from './containers/MetricsDownload';

const Metrics = () => (
  <AccountLayout
    title="Metrics"
    section={{
      title: 'Admin',
      to: {
        type: 'ADMIN_METRICS',
      },
    }}
  >
    <SEOMeta title="Metrics" />
    <AccountLayout.Section>
      <MetricsDownload />
    </AccountLayout.Section>
  </AccountLayout>
);

export default Metrics;
